import { webchatClasses } from '../../styles'
import { WebchatError } from '../../types'
import { BotOff, MonitorCog, Unplug, WifiOff } from 'lucide-react'
import { RestartConversationButton } from '../RestartConversationButton'
import { CloseWindowButton } from '../CloseWindowButton'

type ErrorProps = { error: WebchatError; restartConversation?: () => void; closeWindow?: () => void }

export function ErrorState({ error, restartConversation, closeWindow }: ErrorProps) {
  let errorTitle: string
  let errorIcon: JSX.Element
  const { error: errorStyles } = webchatClasses

  if (error.type === 'configuration') {
    errorTitle = 'Configuration error'
    errorIcon = <MonitorCog {...errorStyles.icon} />
  } else if (error.type === 'bot') {
    errorTitle = 'Bot error'
    errorIcon = <BotOff {...errorStyles.icon} />
  } else if (error.type === 'network') {
    errorTitle = 'Network error'
    errorIcon = <WifiOff {...errorStyles.icon} />
  } else if (error.type === 'disconnected') {
    errorTitle = 'Disconnected'
    errorIcon = <Unplug {...errorStyles.icon} />
  } else {
    errorTitle = 'Unexpected error'
    errorIcon = <BotOff {...errorStyles.icon} />
  }

  return (
    <ErrorPage
      error={error}
      title={errorTitle}
      icon={errorIcon}
      restartConversation={restartConversation}
      closeWindow={closeWindow}
    />
  )
}

type ErrorPageProps = {
  error: WebchatError
  title: string
  icon: JSX.Element
  restartConversation?: () => void
  closeWindow?: () => void
}

function ErrorPage({ error, title, icon, restartConversation, closeWindow }: ErrorPageProps) {
  const { error: errorStyles } = webchatClasses
  return (
    <div {...errorStyles.container}>
      <div {...errorStyles.header.container}>
        {`Webchat ${error.type} error`}
        <div {...errorStyles.header.actions}>
          {restartConversation && (
            <RestartConversationButton
              restartConversation={restartConversation}
              style={{ color: 'white', backgroundColor: 'transparent' }}
            />
          )}
          {closeWindow && (
            <CloseWindowButton onClick={closeWindow} style={{ color: 'white', backgroundColor: 'transparent' }} />
          )}
        </div>
      </div>
      <div {...errorStyles.content}>
        {icon}
        <div {...errorStyles.errorTitle}>{title}</div>
        <div {...errorStyles.errorMessage}>{error.message}</div>
        {error.id && <div {...errorStyles.id}>{error.id}</div>}
      </div>
    </div>
  )
}
